import { context } from 'auth';
import { get } from 'fetch-api';
import { useEffect, useMemo, useState } from 'react';
import { useAuthUser, useAuthUserClaims } from 'subscribe';
import { getCardPartnershipCodeFromLs, setCardPartnershipCodeToLs } from './card.service';

let baseUrl = 'accounts';

export const NBXAccountReferral = {
  init: config => ({ baseUrl } = config),

  getUsedCardPartnershipCode: () =>
    context.account().then(account =>
      context
        .user()
        .then(
          user =>
            get(`${baseUrl}/${account.id}/users/${user.id}/referred`, account) as Promise<{
              code: string;
              partner: string;
            }>
        )
        .then(({ partner }) => partner ?? null)
        .catch(e => {
          if (e.response.status !== 404)
            console.error('Error getting referrals, getUsedCardPartnershipCode:', e);
          return null;
        })
    )
};

const getCardPartnershipCode = async (): Promise<string | null> => {
  const code =
    (await getCardPartnershipCodeFromLs()) ?? (await NBXAccountReferral.getUsedCardPartnershipCode());
  if (code) await setCardPartnershipCodeToLs(code);
  return code;
};

export const useReferralCardPartnership = (
  {
    enabled = true
  }: {
    enabled: boolean;
  } = { enabled: true }
): { code: string | null; loading: boolean; error?: Error } => {
  const [code, setCode] = useState<string | null>(null);
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState<boolean>(true);

  const user = useAuthUser();
  const claims = useAuthUserClaims(user?.id);

  const isOnboarded = useMemo(() => {
    if (!claims || !claims.roles || claims.roles.length === 0) return undefined;
    if (!claims.roles.includes('KYC') || !claims.roles.includes('TOTP')) return false;
    return true;
  }, [claims]);

  useEffect(() => {
    if (isOnboarded) setLoading(false);
    if (enabled && user && isOnboarded === false) {
      getCardPartnershipCode()
        .then(setCode)
        .catch(setError)
        .finally(() => setLoading(false));
    }
  }, [enabled, user, isOnboarded]);

  return { code, loading, error };
};
